<div class="navbar-nav content-header-nav flex-row align-items-center flex-wrap">
    <ng-content></ng-content>
</div>